
<template>
  <section class="benefits" id="card">
    <!-- Huellas eliminadas -->

    <div class="benefits-content">
      <div class="benefits-header">
        <h1 class="main-title"><span class="main-title-light">NUESTROS</span> BENEFICIOS</h1>
      </div>


      <div class="features-container">
        <article class="feature-card">
          <div class="feature-image">
            <img src="../assets/IMG/6.png" alt="Acceso inmediato" />
          </div>
          <h2 class="feature-title">ACCESO INMEDIATO</h2>
          <p class="feature-text">
            Tecnología NFC y código QR para
consultar información en segundos
desde un smartphone.

          </p>
        </article>

        <article class="feature-card">
          <div class="feature-image">
            <img src="../assets/IMG/Beneficio2.png" alt="Tecnología NFC, QR y GPS" />
          </div>
          <h2 class="feature-title">INFORMACIÓN
CENTRALIZADA</h2>
          <p class="feature-text">
            Alergias, condiciones, medicación y
contactos de emergencia en un
solo lugar, siempre disponibles.

          </p>
        </article>

        <article class="feature-card">
          <div class="feature-image">
            <img src="../assets/IMG/Beneficio3.png" alt="Cómoda y resistente" />
          </div>
          <h2 class="feature-title">USO DIARIO
Y SEGURO</h2>
          <p class="feature-text">
            Resistente, cómoda y diseñada
para acompañarte todos los días
con discreción y confianza.

          </p>
        </article>
      </div>
    </div>

    <!-- Huesos eliminados -->
  </section>
</template>

<script>
export default {
  name: "Card",
  props: {},
  data() {
    return {
    };
  },
};
</script>

<style scoped>
.main-title {
  margin-bottom: 0;
  text-align: right;
  flex: 1 1 0;
  color: #c8f34b;
}
.main-title {
  margin-bottom: 0;
}
.main-title-light {
  font-weight: 500;
  color: #c8f34b;
}
.benefits {
  background: #000000 !important;
  display: flex;
  justify-content: center;
  padding: 70px 20px 112px;
  position: relative;
  overflow: hidden;
  scroll-margin-top: 95px;
}



@media (max-width: 600px) {
  .feature-image {
    height: 140px !important;
    min-height: 100px !important;
  }
  .feature-image img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
  }
}

.benefits-content {
  width: 100%;
  max-width: 1260px;
  position: relative;
  z-index: 1;
  transform: translateY(-10px);
}



.main-title {
  font-family: "Barlow", sans-serif;
  font-size: clamp(2.4rem, 5vw, 4.6rem);
  font-weight: 700;
  color: #c8f34b;
  margin: 0 0 44px auto;
  line-height: 1.1;
  max-width: 460px;
  text-align: right;
}

.features-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 34px;
  justify-items: center;
}

.feature-card {
  text-align: center;
  max-width: 390px;
}

.feature-image {
  margin-bottom: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 198px;
  transition: transform 220ms ease;
}

.feature-card:nth-child(1) .feature-image {
  margin-top: -17px;
  height: 260px;
}
.feature-card:nth-child(1) .feature-image img {
  height: 100%;
  width: auto;
  object-fit: contain;
}

.feature-card:nth-child(2) .feature-image,
.feature-card:nth-child(3) .feature-image {
  height: 268px;
  margin-top: -28px;
}

.feature-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 30%;
  border-radius: 14px;
  transition: transform 220ms ease, box-shadow 220ms ease;
}

.feature-card:hover .feature-image img {
  transform: scale(1.035);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
}

.feature-title {
  font-family: "Barlow", sans-serif;
  font-size: clamp(2rem, 3.1vw, 2.8rem);
  font-weight: 700;
  color: #c8f34b;
  margin: 14px 0 14px;
  line-height: 0.95;
}

.feature-text {
  font-family: "Barlow", sans-serif;
  font-size: clamp(1.08rem, 1.5vw, 1.24rem);
  color: #ffffff;
  font-weight: 400;
  line-height: 1.35;
  margin: 0;
}

@media (max-width: 1024px) {
  .benefits {
    padding: 56px 20px 102px;
  }

  .main-title {
    margin-bottom: 34px;
  }

  .paw-top-right,
  .paw-right {
    width: 165px;
  }

  .features-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }

  .feature-card:nth-child(3) {
    grid-column: 1 / -1;
    max-width: 500px;
  }

  .feature-image {
    height: 224px;
  }

  .feature-card:nth-child(1) .feature-image {
    margin-top: -4px;
    height: 250px;
  }

  .feature-card:nth-child(2) .feature-image,
  .feature-card:nth-child(3) .feature-image {
    height: 268px;
    margin-top: -24px;
  }

  .feature-title {
    font-size: clamp(1.8rem, 3.4vw, 2.5rem);
  }
}

@media (max-width: 768px) {
  .benefits {
    padding: 48px 16px 92px;
  }

  .main-title {
    font-size: clamp(2rem, 10vw, 3.3rem);
    margin-bottom: 28px;
    max-width: 320px;
  }

  .paw {
    width: 100px;
  }

  .paw-top-right,
  .paw-right {
    width: 125px;
  }

  .paw-left,
  .paw-right {
    opacity: 1;
  }

  .features-container {
    grid-template-columns: 1fr;
    gap: 38px;
  }

  .feature-card,
  .feature-card:nth-child(3) {
    max-width: 430px;
  }

  .feature-image {
    height: 214px;
  }

  .feature-card:nth-child(1) .feature-image {
    margin-top: -12px;
    height: 230px;
  }

  .feature-card:nth-child(1) .feature-image img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    border-radius: 14px;
  }

  .feature-card:nth-child(2) .feature-image,
  .feature-card:nth-child(3) .feature-image {
    height: 260px;
    margin-top: -20px;
  }
}

@media (max-width: 600px) {
  .feature-image {
    height: 180px !important;
    min-height: 120px !important;
  }

  .feature-image img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
  }

  .feature-card:nth-child(1) .feature-image {
    height: 215px !important;
    margin-top: 0 !important;
  }

  .feature-card:nth-child(1) .feature-image img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    border-radius: 14px;
  }

  .feature-card:nth-child(2) .feature-image,
  .feature-card:nth-child(3) .feature-image {
    height: 210px !important;
    margin-top: -10px !important;
  }
}

@media (max-width: 480px) {
  .benefits {
    padding: 42px 14px 86px;
  }

  .benefits-bones {
    bottom: 0;
    gap: 12px;
    opacity: 0.55;
    transform: translateY(-4px);
  }

  .benefits-bone-icon {
    font-size: 58px;
  }

  .feature-image {
    height: 224px;
  }

  .feature-card:nth-child(1) .feature-image {
    height: 250px !important;
    margin-top: 0 !important;
  }

  .feature-card:nth-child(1) .feature-image img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    border-radius: 14px;
  }

  .feature-card:nth-child(2) .feature-image,
  .feature-card:nth-child(3) .feature-image {
    height: 224px;
    margin-top: -16px;
  }

  .feature-title {
    font-size: clamp(1.7rem, 8vw, 2.1rem);
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .feature-text {
    font-size: 1.1rem;
  }
}</style>
